/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { JokerPersonnePhysiqueDto } from '../models/joker-personne-physique-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des jokers
 */
@Injectable({
  providedIn: 'root',
})
export class JokersPersonnesPhysiquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation jokerPersonnePhysiqueGetList
   */
  static readonly JokerPersonnePhysiqueGetListPath = '/api/jokers-personnes-physiques/list';

  /**
   * Renvoie la liste des jokers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<JokerPersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JokerPersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des jokers.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGetList(params?: {
  }): Observable<Array<JokerPersonnePhysiqueDto>> {

    return this.jokerPersonnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JokerPersonnePhysiqueDto>>) => r.body as Array<JokerPersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiqueLoadList
   */
  static readonly JokerPersonnePhysiqueLoadListPath = '/api/jokers-personnes-physiques/load-list';

  /**
   * Renvoie la liste des jokers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des jokers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.jokerPersonnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiqueLoadList2
   */
  static readonly JokerPersonnePhysiqueLoadList2Path = '/api/jokers-personnes-physiques/personne/load-list/{personnePhysiqueId}';

  /**
   * Liste des jokers pour la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiqueLoadList2$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueLoadList2Path, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Liste des jokers pour la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiqueLoadList2(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.jokerPersonnePhysiqueLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiqueGet
   */
  static readonly JokerPersonnePhysiqueGetPath = '/api/jokers-personnes-physiques/personne/{personnePhysiqueId}/{id}';

  /**
   * Renvoie le joker de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant joker
     */
    id: number;
  }): Observable<StrictHttpResponse<JokerPersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JokerPersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie le joker de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGet(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant joker
     */
    id: number;
  }): Observable<JokerPersonnePhysiqueDto> {

    return this.jokerPersonnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<JokerPersonnePhysiqueDto>) => r.body as JokerPersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiqueGet2
   */
  static readonly JokerPersonnePhysiqueGet2Path = '/api/jokers-personnes-physiques/{id}';

  /**
   * Renvoie le joker spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGet2$Response(params: {

    /**
     * Identifiant joker
     */
    id: number;
  }): Observable<StrictHttpResponse<JokerPersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JokerPersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie le joker spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueGet2(params: {

    /**
     * Identifiant joker
     */
    id: number;
  }): Observable<JokerPersonnePhysiqueDto> {

    return this.jokerPersonnePhysiqueGet2$Response(params).pipe(
      map((r: StrictHttpResponse<JokerPersonnePhysiqueDto>) => r.body as JokerPersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiquePut
   */
  static readonly JokerPersonnePhysiquePutPath = '/api/jokers-personnes-physiques/{id}';

  /**
   * Met à jour le joker spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiquePut$Response(params: {

    /**
     * Identifiant du joker
     */
    id: number;

    /**
     * Joker
     */
    body: JokerPersonnePhysiqueDto
  }): Observable<StrictHttpResponse<JokerPersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JokerPersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Met à jour le joker spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiquePut(params: {

    /**
     * Identifiant du joker
     */
    id: number;

    /**
     * Joker
     */
    body: JokerPersonnePhysiqueDto
  }): Observable<JokerPersonnePhysiqueDto> {

    return this.jokerPersonnePhysiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<JokerPersonnePhysiqueDto>) => r.body as JokerPersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiqueDelete
   */
  static readonly JokerPersonnePhysiqueDeletePath = '/api/jokers-personnes-physiques/{id}';

  /**
   * Supprime le joker spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueDelete$Response(params: {

    /**
     * Identifiant du joker à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le joker spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jokerPersonnePhysiqueDelete(params: {

    /**
     * Identifiant du joker à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.jokerPersonnePhysiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation jokerPersonnePhysiquePost
   */
  static readonly JokerPersonnePhysiquePostPath = '/api/jokers-personnes-physiques';

  /**
   * Crée le joker spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jokerPersonnePhysiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiquePost$Response(params: {

    /**
     * Joker
     */
    body: JokerPersonnePhysiqueDto
  }): Observable<StrictHttpResponse<JokerPersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, JokersPersonnesPhysiquesService.JokerPersonnePhysiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JokerPersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Crée le joker spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jokerPersonnePhysiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jokerPersonnePhysiquePost(params: {

    /**
     * Joker
     */
    body: JokerPersonnePhysiqueDto
  }): Observable<JokerPersonnePhysiqueDto> {

    return this.jokerPersonnePhysiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<JokerPersonnePhysiqueDto>) => r.body as JokerPersonnePhysiqueDto)
    );
  }

}
